// Selectors


import { RootState } from '../../store';

export const trustedIssuerListSelector = (state: RootState) => state.trustedIssuerListState


